import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDateClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M5.167 3.167V1.833m5.666 1.334V1.833m.5 8v1.5L12.5 12.5m-6.667 1H4.5a2 2 0 0 1-2-2V5.167a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v.666M9.994 8.101a3.499 3.499 0 1 1 2.678 6.464 3.499 3.499 0 0 1-2.678-6.464"
	})
});
export default SvgDateClock;
